










































































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import SettingParams from "./settingparams.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageMeterInfoRequest extends PageRequest {
  keyword: string;
  areaId: number;
  onlyNo: number;
  controleType: number = 0;
  onoffstate: number = 9;
  linestate: number = 9;
  meterLevel: number = 0;
  meterType: number = 0;
  transferType: number = 0;
}

@Component({
  components: {
    SettingParams
  },
})
export default class MeterInfoParams extends AbpBase {
  //filters
  pagerequest: PageMeterInfoRequest = new PageMeterInfoRequest();
  columnlist: any[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  meterlist: any[] = [];
  customerlist: any[] = [];
  choosemeters: Array<any> = [];
  pricelist: any[] = [];
  meterId: string = null;
  height: number = 300; //表格高度
  menuId: number = 0;
  choosecolumn: any[] = []; //右侧选项
  meternolist: any[] = [];

  showcolumn: boolean = false; //显示列选择窗口
  // orgdivertModalShow: boolean = false; //组织转移
  // priceModalShow: boolean = false; //价格设置
  // waringModalShow: boolean = false; //告警值设置
  // overuseModalShow: boolean = false; //透支量设置
  // baseuseModalShow: boolean = false; //底度数设置
  // readlistModalShow: boolean = false; //采集记录
  // controlModalShow: boolean = false; //控制类型
  // transferaccountShow: boolean = false; //过户
  settingparamsModalShow: boolean = false;//设置参数
  splitnum: number = 0.15;

  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }

  //获取菜单Id
  getmenu() {
    let menulist = JSON.parse(localStorage.getItem("userAuth"));
    let menu = menulist.filter((ele) => {
      return ele.value == "meterinfo";
    });
    if (menu.length > 0) {
      this.menuId = menu[0].id;
    }
    let se = this.columns.filter((ele) => {
      return (
        ele.sortId == 0 ||
        ele.sortId == 1 ||
        ele.sortId == 5 ||
        ele.sortId == 73 ||
        ele.sortId == 76 ||
        ele.sortId == 99
      );
    });
    se.forEach((ele) => {
      this.columnlist.push(ele);
    });
  }
  //获取自定义字段
  async getuserfields() {
    let res = await this.$store.dispatch({
      type: "userfield/getuserfield",
      data: { menuId: this.menuId },
    });
    //把列加入右侧选择列表
    this.columns.forEach((ele) => {
      if (
        ele.sortId != 0 &&
        ele.sortId != 1 &&
        ele.sortId != 5 &&
        ele.sortId != 73 &&
        ele.sortId != 76 &&
        ele.sortId != 99
      ) {
        this.choosecolumn.push({
          fieldName: ele.key,
          isShow: true, //默认全部显示
          sortCode: ele.sortId,
          showTag: ele.title,
          menuId: this.menuId,
        });
      }
    });
    //如果设置了自定义列
    if (res.length > 0) {
      let restrue = res.filter((ele) => {
        return ele.isShow == true;
      });
      restrue.forEach((ele) => {
        let col = this.columns.filter((colum) => {
          if (ele.fieldName == "customerID") return colum.key == "customerName";
          else if (ele.fieldName == "meterId") return colum.key == "meterNo";
          else if (ele.fieldName == "areaId") return colum.key == "fullName";
          else if (ele.fieldName == "organizationId")
            return colum.key == "displayName";
          else return colum.key == ele.fieldName;
        });
        //加入显示列
        if (col.length > 0) {
          if (ele.sortCode > 0) {
            col[0].sortId = ele.sortCode;
          }
          this.columnlist.push(col[0]);
        }
      });
      //改变左侧菜单显示
      this.choosecolumn.forEach((ele) => {
        let col = restrue.filter((colum) => {
          if (ele.fieldName == "customerName")
            return colum.fieldName == "customerID";
          else if (ele.fieldName == "meterNo")
            return colum.fieldName == "meterId";
          else if (ele.fieldName == "fullName")
            return colum.fieldName == "areaId";
          else if (ele.fieldName == "displayName")
            return colum.fieldName == "organizationId";
          else return colum.fieldName == ele.fieldName;
        });

        if (col.length > 0) {
          ele.isShow = col[0].isShow;
        } else {
          ele.isShow = false;
        }
      });
    } else {
      this.columnlist = this.columns;
    }
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  //改变显示
  handleChange(event: any, val: any) {
    if (event) {
      //选中显示
      let showcol = this.columns.filter((col) => {
        return col.key === val;
      });
      if (showcol.length > 0) {
        let sh = this.choosecolumn.filter((p) => {
          return p.fieldName == val;
        });
        if (sh.length > 0) {
          showcol[0].sortId = sh[0].sortCode;
        }
        this.columnlist.push(showcol[0]);
      }
    } else {
      //不显示
      this.columnlist = this.columnlist.filter((col) => {
        return col.key !== val;
      });
    }
    //排序
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }

  get list() {
    return this.$store.state.meterinfo.list;
  }
  get loading() {
    return this.$store.state.meterinfo.loading;
  }
  showcol() {
    this.showcolumn = true;
  }
  //获取
  getAreaId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("meterinfo/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  //左侧菜单树
  getAreaTree() {
    this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  pageChange(page: number) {
    this.$store.commit("meterinfo/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("meterinfo/setPageSize", pagesize);
    this.getpage();
  }
  getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //this.pagerequest.transferType = 34;
    this.$store.dispatch({
      type: "meterinfo/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.meterinfo.pageSize;
  }
  get totalCount() {
    return this.$store.state.meterinfo.totalCount;
  }
  get currentPage() {
    return this.$store.state.meterinfo.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "center",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      type: "selection",
      width: 60,
      fixed: "left",
      align: "center",
      sortId: 0,
    },
    {
      title: this.L("Organizations"),
      key: "displayName",
      resizable: true,
      width: 130,
      align: "center",
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.displayName,
            },
          },
          params.row.displayName
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "fullName",
      sortable: true,
      width: 90,
      resizable: true,
      align: "center",
      sortId: 3,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.fullName,
            },
          },
          params.row.fullName
        );
      },
    },
    {
      sortable: true,
      title: this.L("MeterId"),
      key: "meterNo",
      resizable: true,
      width: 130,
      fixed: "left",
      align: "center",
      sortId: 4,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      sortable: true,
      title: this.L("RoomNo"),
      key: "roomNo",
      resizable: true,
      width: 130,
      fixed: "left",
      align: "center",
      sortId: 5,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      sortable: true,
      title: this.L("LastReadTime"),
      key: "lastReadTime",
      width: 150,
      resizable: true,
      align: "center",
      sortId: 6,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReadTime == null
            ? ""
            : Moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      sortable: true,
      title: this.L("ReadNum"),
      key: "lastReadNum",
      width: 150,
      resizable: true,
      align: "center",
      sortId: 7,
    },

    // {
    //   title: this.L("First") + this.L("Step") + "/" + this.L("Flat"),
    //   key: "flatReadNum",
    //   width: 130,
    //   sortId: 10,
    //   align: "center",
    //   resizable: true,
    // },
    // {
    //   title: this.L("Second") + this.L("Step") + "/" + this.L("Tip"),
    //   key: "tipReadNum",
    //   width: 130,
    //   align: "center",
    //   resizable: true,
    //   sortId: 11,
    // },
    // {
    //   title: this.L("Third") + this.L("Step") + "/" + this.L("Peak"),
    //   key: "peakReadNum",
    //   sortId: 12,
    //   width: 130,
    //   align: "center",
    //   resizable: true,
    // },
    // {
    //   title: this.L("Four") + this.L("Step") + "/" + this.L("Valley"),
    //   key: "valleyReadNum",
    //   width: 130,
    //   resizable: true,
    //   align: "center",
    //   sortId: 13,
    // },
    // {
    //   title: this.L("BalanceUse"),
    //   key: "totalBalanceUse",
    //   width: 130,
    //   resizable: true,
    //   align: "center",
    //   sortId: 8,
    // },
    // {
    //   title: this.L("Balance"),
    //   key: "totalBalance",
    //   width: 130,
    //   sortId: 9,
    //   align: "center",
    //   resizable: true,
    // },

    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("First") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Flat") +
    //     this.L("TotalUse"),
    //   key: "firstTotal",
    //   width: 150,
    //   align: "center",
    //   sortId: 14,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("First") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Flat") +
    //     this.L("BalanceUse"),
    //   key: "firstBalanceUse",
    //   width: 150,
    //   align: "center",
    //   sortId: 15,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("First") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Flat") +
    //     this.L("Balance"),
    //   key: "firstBalanceTotal",
    //   width: 150,
    //   align: "center",
    //   sortId: 16,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("Second") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Tip") +
    //     this.L("TotalUse"),
    //   key: "secondTotal",
    //   width: 150,
    //   align: "center",
    //   sortId: 17,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("Second") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Tip") +
    //     this.L("BalanceUse"),
    //   key: "secondBalanceUse",
    //   width: 150,
    //   align: "center",
    //   sortId: 18,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("Second") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Tip") +
    //     this.L("Balance"),
    //   key: "secondBalanceTotal",
    //   width: 150,
    //   align: "center",
    //   sortId: 19,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("Third") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Peak") +
    //     this.L("TotalUse"),
    //   key: "thirdTotal",
    //   width: 150,
    //   align: "center",
    //   sortId: 20,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("Third") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Peak") +
    //     this.L("BalanceUse"),
    //   key: "thirdBalanceUse",
    //   width: 150,
    //   align: "center",
    //   sortId: 21,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("Third") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Peak") +
    //     this.L("Balance"),
    //   key: "thirdBalanceTotal",
    //   width: 150,
    //   align: "center",
    //   sortId: 22,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("Four") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Valley") +
    //     this.L("TotalUse"),
    //   key: "fourTotal",
    //   width: 150,
    //   align: "center",
    //   sortId: 23,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("Four") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Valley") +
    //     this.L("BalanceUse"),
    //   key: "fourBalanceUse",
    //   width: 150,
    //   align: "center",
    //   sortId: 24,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title:
    //     this.L("Four") +
    //     this.L("Step") +
    //     "/" +
    //     this.L("Valley") +
    //     this.L("Balance"),
    //   key: "fourBalanceTotal",
    //   width: 150,
    //   align: "center",
    //   sortId: 25,
    // },
    {
      sortable: true,
      title: this.L("OnLine") + this.L("State"),
      key: "lineState",
      resizable: true,
      width: 130,
      align: "center",
      sortId: 26,
      render: (h: any, params: any) => {
        let str = this.L("OffLine");
        let id = params.row.lineState;
        if (id == 1) {
          str = this.L("OnLine");
        }
        return h("span", str);
      },
    },
    {
      title: this.L("Device") + this.L("State"),
      key: "deviceState",
      width: 130,
      resizable: true,
      align: "center",
      sortId: 27,
      render: (h: any, params: any) => {
        let str = this.L("Unknown");
        let id = params.row.deviceState;
        if (id == 1) {
          str = this.L("Registered");
        } else if (id == 2) {
          str = this.L("Activation");
        } else if (id == 3) {
          str = this.L("Cancellation");
        }
        return h("span", str);
      },
    },
    {
      title: this.L("OnOff") + this.L("State"),
      key: "onOffState",
      resizable: true,
      width: 130,
      align: "center",
      sortId: 28,
      render: (h: any, params: any) => {
        let str = this.L("Unknown");
        let id = params.row.onOffState;
        if (id == 1) {
          str = this.L("On");
        } else if (id == 2) {
          str = this.L("Off");
        } else if (id == 3) {
          str = this.L("Abnormal");
        }
        return h("span", str);
      },
    },
    {
      sortable: true,
      resizable: true,
      title: this.L("CurrentTenant"),
      key: "customerName",
      width: 130,
      align: "center",
      sortId: 29,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.customerName,
            },
          },
          params.row.customerName
        );
      },
    },
    // {
    //   sortable: true,
    //   title: this.L("Price") + this.L("Name"),
    //   key: "priceId",
    //   width: 130,
    //   align: "center",
    //   sortId: 30,
    //   resizable: true,
    //   render: (h: any, params: any) => {
    //     let id = params.row.priceId;
    //     let info = this.pricelist.filter((p) => {
    //       return p.id == id;
    //     });
    //     return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
    //   },
    // },
    // {
    //   title: this.L("Controle") + this.L("Category"),
    //   key: "controleType",
    //   sortable: true,
    //   width: 110,
    //   align: "center",
    //   resizable: true,
    //   sortId: 31,
    //   render: (h: any, params: any) => {
    //     let id = params.row.controleType;
    //     let ite = JSON.parse(localStorage.getItem("itemdetail"));
    //     let info = ite.filter((p) => {
    //       return p.id == id;
    //     });
    //     return h("span", info.length > 0 ? info[0].name : "未知");
    //   },
    // },
    // {
    //   sortable: true,
    //   title: this.L("First") + this.L("Waring") + this.L("Value"),
    //   key: "firstBalanceWaring",
    //   width: 130,
    //   align: "center",
    //   resizable: true,
    //   sortId: 32,
    // },
    // {
    //   sortable: true,
    //   title: this.L("Second") + this.L("Waring") + this.L("Value"),
    //   key: "secondBalanceWaring",
    //   width: 130,
    //   align: "center",
    //   sortId: 33,
    //   resizable: true,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   align: "center",
    //   width: 130,
    //   title: this.L("Third") + this.L("Waring") + this.L("Value"),
    //   key: "thirdBalanceWaring",
    //   sortId: 34,
    // },
    // {
    //   sortable: true,
    //   title: this.L("Waring") + this.L("Num"),
    //   key: "isWaring",
    //   width: 130,
    //   align: "center",
    //   resizable: true,
    //   sortId: 35,
    // },
    // {
    //   sortable: true,
    //   resizable: true,
    //   title: this.L("OverUse"),
    //   key: "overUse",
    //   width: 130,
    //   align: "center",
    //   sortId: 36,
    // },
    // {
    //   sortable: true,
    //   title: this.L("BaseUse"),
    //   key: "baseUse",
    //   width: 130,
    //   align: "center",
    //   resizable: true,
    //   sortId: 37,
    // },
    {
      title: this.L("CSQ"),
      key: "csq",
      width: 90,
      align: "center",
      sortId: 38,
      resizable: true,
    },
    {
      title: this.L("RSRQ"),
      key: "rsrq",
      width: 90,
      align: "center",
      resizable: true,
      sortId: 39,
    },
    {
      title: this.L("SNR"),
      key: "snr",
      width: 90,
      sortId: 40,
      align: "center",
      resizable: true,
    },
    {
      title: this.L("Cover") + this.L("Level"),
      key: "coverLevel",
      resizable: true,
      width: 130,
      align: "center",
      sortId: 41,
    },
    {
      title: this.L("Cell") + "Id",
      key: "cellId",
      width: 130,
      sortId: 42,
      align: "center",
      resizable: true,
    },

    {
      sortable: true,
      title: this.L("OnLine") + this.L("Time"),
      key: "onLineTime",
      resizable: true,
      width: 150,
      align: "center",
      sortId: 43,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.onLineTime == null
            ? ""
            : Moment(params.row.onLineTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      sortable: true,
      title: this.L("OffLine") + this.L("Time"),
      key: "offLineTime",
      resizable: true,
      width: 150,
      align: "center",
      sortId: 44,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.offLineTime == null
            ? ""
            : Moment(params.row.offLineTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Voltage"),
      key: "voltage",
      width: 90,
      align: "center",
      sortId: 45,
      resizable: true,
    },
    // {
    //   title: this.L("Waring") + "Id",
    //   key: "alarm",
    //   width: 90,
    //   align: "center",
    //   sortId: 46,
    //   resizable: true,
    // },
    // {
    //   title:
    //     this.L("Continued") +
    //     this.L("OverFlow") +
    //     this.L("Waring") +
    //     this.L("Value"),
    //   key: "overFlow",
    //   resizable: true,
    //   align: "center",
    //   width: 180,
    //   sortId: 47,
    // },
    // {
    //   title: this.L("Continued") + this.L("OverFlow") + this.L("Time"),
    //   key: "overTime",
    //   width: 180,
    //   align: "center",
    //   resizable: true,
    //   sortId: 48,
    // },
    // {
    //   title:
    //     this.L("Continued") +
    //     this.L("OppoFlow") +
    //     this.L("Waring") +
    //     this.L("Value"),
    //   key: "oppoFlow",
    //   width: 180,
    //   align: "center",
    //   sortId: 49,
    //   resizable: true,
    // },
    // {
    //   title: this.L("Continued") + this.L("OppoFlow") + this.L("Time"),
    //   key: "oppoTime",
    //   resizable: true,
    //   width: 130,
    //   align: "center",
    //   sortId: 50,
    // },
    // {
    //   title: this.L("Immediate") + this.L("Waring") + "Id",
    //   key: "rAlarmID",
    //   width: 130,
    //   resizable: true,
    //   align: "center",
    //   sortId: 51,
    // },
    {
      title: this.L("IP"),
      key: "serverIP",
      resizable: true,
      width: 130,
      align: "center",
      sortId: 52,
    },
    {
      title: this.L("Port"),
      key: "serverPort",
      width: 130,
      sortId: 53,
      align: "center",
      resizable: true,
    },
    {
      title: this.L("APN"),
      key: "apn",
      width: 130,
      resizable: true,
      align: "center",
      sortId: 54,
    },
    {
      title:
        this.L("Cycle") +
        this.L("Reporting") +
        this.L("Dispersed") +
        this.L("Start") +
        this.L("Time"),
      key: "cycSTime",
      width: 180,
      sortId: 55,
      align: "center",
      resizable: true,
    },
    {
      title:
        this.L("Cycle") +
        this.L("Reporting") +
        this.L("Dispersed") +
        this.L("End") +
        this.L("Time"),
      key: "cycETime",
      width: 180,
      align: "center",
      sortId: 56,
      resizable: true,
    },
    {
      title:
        this.L("Cycle") +
        this.L("Reporting") +
        this.L("Dispersed") +
        this.L("Assessor"),
      key: "timeLength",
      width: 180,
      align: "center",
      sortId: 57,
      resizable: true,
    },
    {
      title: this.L("Cycle") + this.L("Reporting") + this.L("Rate"),
      key: "cycRate",
      width: 180,
      align: "center",
      sortId: 58,
      resizable: true,
    },
    {
      title: this.L("Reporting") + this.L("Retry") + this.L("Num"),
      key: "retryTimes",
      width: 180,
      align: "center",
      sortId: 59,
      resizable: true,
    },
    {
      title: this.L("Voltage") + this.L("Waring") + this.L("Value"),
      key: "voltAlarm",
      width: 180,
      align: "center",
      sortId: 60,
      resizable: true,
    },
    {
      title:
        this.L("Intensive") +
        this.L("Reporting") +
        this.L("Start") +
        this.L("Time"),
      key: "iStartHour",
      width: 170,
      align: "center",
      resizable: true,
      sortId: 61,
    },
    {
      title: this.L("Valve") + this.L("State"),
      key: "valveStatus",
      width: 130,
      align: "center",
      sortId: 62,
      resizable: true,
    },
    {
      title: this.L("Retry") + this.L("Cycle"),
      key: "retryCycle",
      width: 180,
      align: "center",
      sortId: 63,
      resizable: true,
    },
    {
      title: this.L("Cycle") + this.L("Interval"),
      key: "cycSendPeriod",
      width: 180,
      align: "center",
      resizable: true,
      sortId: 64,
    },
    {
      title: this.L("Intensive") + this.L("Cycle") + this.L("Interval"),
      key: "iCycSendPeriod",
      width: 180,
      align: "center",
      sortId: 65,
      resizable: true,
    },
    {
      title: this.L("TerminalTime"),
      key: "terminalTime",
      width: 180,
      align: "center",
      sortId: 66,
      resizable: true,
    },
    {
      title: this.L("TimeDiff"),
      key: "timeDiff",
      width: 180,
      align: "center",
      sortId: 67,
      resizable: true,
    },
    {
      title: this.L("RunDays"),
      key: "runDays",
      width: 130,
      align: "center",
      sortId: 68,
      resizable: true,
    },
    {
      title: this.L("TVersion"),
      key: "tversion",
      width: 130,
      align: "center",
      resizable: true,
      sortId: 69,
    },
    {
      title: this.L("Rheology"),
      key: "rheology",
      width: 130,
      align: "center",
      sortId: 70,
      resizable: true,
    },
    {
      title: this.L("PressureChangeing"),
      key: "pressureChangeing",
      width: 130,
      resizable: true,
      align: "center",
      sortId: 71,
    },
    {
      title: this.L("RecharMinValue"),
      key: "recharMinValue",
      width: 130,
      align: "center",
      sortId: 72,
      resizable: true,
    },
    {
      sortable: true,
      title: this.L("MeterCaliber"),
      key: "meterCaliber",
      width: 150,
      align: "center",
      resizable: true,
      sortId: 73,
    },
    {
      sortable: true,
      title: this.L("ByCustomer"),
      key: "byCustomer",
      width: 150,
      align: "center",
      resizable: true,
      sortId: 74,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.byCustomer == true ? this.L("Started") : this.L("NoStart")
        );
      },
    },
    {
      sortable: true,
      title: this.L("ControlExpenses"),
      key: "controlExpenses",
      width: 150,
      align: "center",
      resizable: true,
      sortId: 75,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.controlExpenses == true
            ? this.L("Started")
            : this.L("NoStart")
        );
      },
    },
    {
      sortable: true,
      title: this.L("CollectorId"),
      key: "no",
      width: 150,
      align: "center",
      resizable: true,
      sortId: 99,
    },
    // {
    //   title: this.L("Actions"),
    //   key: "Actions",
    //   width: 200,
    //   fixed: "right",
    //   sortId: 76,
    //   render: (h: any, params: any) => {
    //     let readnul = this.checkButtonAuth('adjustmentReadNum');
    //     let setbalance = this.checkButtonAuth('adjustmentBalance');
    //     return h("div", [
    //       setbalance ? h("Button", {
    //         props: {
    //           type: "warning",
    //           size: "small",
    //         },
    //         style: {
    //           marginRight: "5px",
    //         },
    //         on: {
    //           click: () => {
    //             // this.meterId = params.row.meterId;
    //             // this.adjustmentBalanceModalShow = true;
    //             this.showAdjmentData(params.row.meterId, 1);
    //           },
    //         },
    //       },
    //         this.L("AdjustmentBalance"),
    //       ) : '',
    //       readnul ? h("Button", {
    //         props: {
    //           type: "error",
    //           size: "small",
    //         },
    //         style: {
    //           marginRight: "5px",
    //         },
    //         on: {
    //           click: () => {
    //             // this.meterId = params.row.meterId;
    //             // this.adjustmentreadnumModalShow = true;
    //             this.showAdjmentData(params.row.meterId, 2);
    //           },
    //         },
    //       },
    //         this.L("AdjustmentReadNum"),
    //       ) : '',
    //     ]);
    //   },
    // },
  ];
  created() {
    this.getmenu();
    this.getuserfields();
    this.pagerequest.linestate = 9;
    this.getAreaTree();
    this.getItemDetail();
    this.getprice();
    this.getpage();
  }
  //选择
  onrowselect(val, index) {
    this.choosemeters.push(index.meterId);
  }
  //取消选择
  onrowselected(val, index) {
    this.choosemeters = this.choosemeters.filter((ele) => ele != index.meterId);
  }
  //全选
  handall(selection) {
    if (selection.length > 0) {
      this.choosemeters = [];
      selection.forEach((ele) => {
        this.choosemeters.push(ele.meterId);
      });
    }
  }
  //取消全选
  handallcancel(selection) {
    this.choosemeters = [];
  }
  //数据
  data() {
    return {
      controleType: [],
      meterType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  //数据字典明细
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let control = detaillist.filter((p) => {
        return p.itemId == 14;
      });
      control.forEach((ele) => {
        this.$data.controleType.push({
          label: ele.name,
          value: ele.id,
        });
      });
    }
    let metert = detaillist.filter((p) => {
      return p.itemId == 7;
    });
    metert.forEach((ele) => {
      this.$data.meterType.push({
        label: ele.name,
        value: ele.id,
      });
    });
  }
  //价格
  getprice() {
    this.$store
      .dispatch("price/getPriceList")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.pricelist.push(ele);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //设置参数
  async settingparams() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Meter"),
      });
      return;
    }
    this.choosemeters = [];
    this.meternolist = [];
    if (val.length > 0) {
      val.forEach((ele) => {
        this.choosemeters.push(ele.meterId);
        this.meternolist.push(ele.meterNo);
      });
    }
    this.settingparamsModalShow = true;
  }
  //导出数据
  async exportData(type: any) {
    //console.log(type);
    let fileName = Moment().format("x");
    if (type === 'exportCurrentPage') {//当前页数据
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, columns: this.columnlist });
    } else {
      this.pagerequest.skipCount = 0;
      this.pagerequest.maxResultCount = 10000;
      await this.$store.dispatch({
        type: "meter/getAll",
        data: this.pagerequest,
      });
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, data: this.$store.state.meter.list, columns: this.columnlist });
    }
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 380;
    } else {
      this.height = window.innerHeight - 420;
    }
  }
}
